// ─── Suppliers ────────────────────────────────────────────────────────────

import { apiRequest } from './http';
import { createEntityCrudClient } from './crudFactory';

export interface Supplier {
  entityId: string;
  entityType: 'TechnologySupplier';
  name: string;
  description?: string;
  websiteUrl?: string;
  tags?: string[];
}

export interface CreateSupplierInput {
  name: string;
  description?: string;
  websiteUrl?: string;
}

export interface UpdateSupplierInput {
  name?: string;
  description?: string;
  websiteUrl?: string;
}

const client = createEntityCrudClient<Supplier, CreateSupplierInput, UpdateSupplierInput>(
  '/suppliers'
);

export async function createSupplier(input: CreateSupplierInput): Promise<Supplier> {
  return client.create(input);
}

export async function listSuppliers(): Promise<Supplier[]> {
  const result = await apiRequest<{ items: Supplier[] }>('/suppliers');
  return result.items;
}

export async function updateSupplier(id: string, input: UpdateSupplierInput): Promise<Supplier> {
  return client.update(id, input);
}

export async function deleteSupplier(id: string): Promise<void> {
  return client.remove(id);
}
